import React, { useEffect, useRef, useState } from 'react'
import {
  CaretDownFilled,
  QuestionCircleTwoTone,
  SettingOutlined,
} from '@ant-design/icons'
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Popover,
  Row,
  Select,
  Switch,
  Radio,
} from 'antd'
import styles from './Examinetreat.module.css'
import {
  detailExamine,
  getSortNoAsync,
  logoutorEnableExamineAsync,
  selectDetail,
  selectTargetId,
  setDetail,
  setTargetId,
  submitExamineAsync,
} from './examinetreatSlice'
import { useDispatch, useSelector } from 'react-redux'
import { isSameName } from '../../utils/fieldsUtils'
import cnchar from 'cnchar'
import {
  BillingCategories,
  BillingCategoryName,
  TreatmentBillingCategories,
} from '../../models/billingCategory'
import { RootDispatch } from '../../app/store'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  getServerGoodsNo,
  getZjWbCodes,
  selectShopNo,
} from '../commodity/commoditySlice'
import { getChrgitmLvName } from '../../models/commodity'
import { selectInsuranceArray } from '../../app/applicationSlice'
import { MedicalModal } from '../commodity/medical/MedicalModal'
import { RecipeItemFieldInput } from '../treatment/editor/components/RecipeItemFieldInput'
import { pinyin } from 'pinyin-pro'
import { defaultXianBingListAsync } from '../treatment/tcmCases/tcmCasesSlice'
import { SettingTreatmentParts } from './settingTreatmentParts'
const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
}
const layouts = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
}
const { Option } = Select

const { TextArea } = Input

export const ExamineModal = (props: {
  categoryList: any
  visible: boolean
  onOk: () => void
  onCancel: () => void
  info?: any
}) => {
  const inputRef = useRef<Input>(null)

  const [state, setState] = useState('新增')

  const detail: any = useSelector(selectDetail)

  const targetId = useSelector(selectTargetId)

  const [form] = Form.useForm()

  const shopNo = useSelector(selectShopNo)

  const dispatch = useDispatch<RootDispatch>()

  const [medicalModalInfo, setMedicalModalInfo] = useState<any>()

  const [medicalModalVisible, setMedicalModalVisible] = useState(false)

  const [YBSearchTag, setYBSearchTag] = useState(false)

  const [editTreatmentParts, setEditTreatmentParts] = useState(false)

  const [treatmentPartsList, setTreatmentPartsList] = useState<any>([])

  const [componentItem, setComponentItem] = useState<any>({
    name: '',
    billingCategory: '',
    tenantSupplierName: '',
    transitionScale: '',
    approvalNumber: '',
  })

  const insuranceArray = useSelector(selectInsuranceArray)

  useEffect(() => {
    setYBSearchTag(false)
  }, [])

  useEffect(() => {
    if (targetId && props.info) {
      setState('修改')
      dispatch(
        detailExamine({
          id: targetId,
          billingCategory: props.info?.billingCategory || '',
          hilistCode: props.info?.hilistCode || '',
          insuranceCode: props.info?.insuranceCode || '',
          mappingId: props.info?.mappingId || '',
        })
      )
    } else {
      setState('新增')
    }
  }, [targetId, props.info])

  useEffect(() => {
    if (!props.visible) {
      refreshMessage()
    } 
  }, [props.visible])

  useEffect(() => {
    if (props.visible && !targetId) {
      dispatch(getSortNoAsync())
        .then(unwrapResult)
        .then((v) => {
          form.setFieldsValue({
            sortNo: v == -1 ? '' : v,
          })
        })
    }

    if (props.visible) {
      dispatch(defaultXianBingListAsync(2))
        .then(unwrapResult)
        .then((res) => {
          setTreatmentPartsList(res)
        })
    }
  }, [props.visible, targetId])

  useEffect(() => {
    if (JSON.stringify(detail) !== '{}') {
      form.setFieldsValue({
        ...detail,
        costPrice: detail?.costPrice == -1 ? '' : detail?.costPrice,
        sortNo: detail?.sortNo == -1 ? '' : detail?.sortNo,
        tax: detail?.tax == -1 ? '' : detail?.tax,
        forceYearAccount: Number(detail?.forceYearAccount) > 0 ? Number(detail?.forceYearAccount) : 0,
        ...detail?.mixInsuranceCatalog,
        chrgitmLv: getChrgitmLvName(detail?.mixInsuranceCatalog?.chrgitmLv),
        treatmentParts: detail?.treatmentParts
          ? detail?.treatmentParts?.split(',')
          : [],
      })
      setComponentItem({
        name: detail?.name ,
        billingCategory: detail?.billingCategory,
        tenantSupplierName: detail?.tenantSupplierName,
        transitionScale: detail?.transitionScale,
        approvalNumber: detail?.approvalNumber,
      })
    }
  }, [detail])
  useEffect(() => {
    if (!props.visible) {
      setComponentItem({
        name: '',
        billingCategory: '',
        tenantSupplierName: '',
        transitionScale: '',
        approvalNumber: '',
      })
    }
  }, [props.visible])

  useEffect(() => {
    if (shopNo) {
      form.setFieldsValue({
        no: shopNo,
      })
    }
  }, [shopNo])

  const refreshMessage = () => {
    setState('新增')
    form.resetFields()

    dispatch(setTargetId(0))
    dispatch(setDetail({}))
    props.onCancel()
  }

  useEffect(() => {
    if (props.visible && !targetId) {
      // 添加一个小延迟，确保DOM元素已经完全渲染后再调用focus
      setTimeout(() => {
        inputRef.current?.focus()
      }, 100)
    }
  }, [props.visible, targetId])


  return (
    <div>
      <Modal
        title={state + '诊疗目录'}
        visible={props.visible}
        okText='确认'
        cancelText='取消'
        className={`${styles.form} ${styles.examinetreatForm}`}
        // bodyStyle={{ height: '440px' }}
        onOk={() => {
          setState('新增')
          props.onOk()
          dispatch(setTargetId(0))
          dispatch(setDetail({}))
        }}
        onCancel={() => {
          setState('新增')
          form.resetFields()
          dispatch(setTargetId(0))
          dispatch(setDetail({}))
          props.onCancel()
        }}
        footer={null}
      >
        <Form
          autoComplete='off'
          {...layout}
          form={form}
          name='basic'
          onFinish={(fs) => {
            let submitBody: any = {}

            if (JSON.stringify(detail) !== '{}') {
              let limitId = ''
              if (medicalModalInfo) {
                limitId = medicalModalInfo?.limitId
              } else {
                limitId = detail?.mixInsuranceCatalog?.limitId
              }
              submitBody = {
                treatmentServiceCatalog: {
                  ...fs,
                  id: detail?.id,
                  treatmentCategory: fs.treatmentCategory
                    ? fs.treatmentCategory
                    : ' ',
                  forceYearAccount: fs.forceYearAccount ? fs.forceYearAccount : 0,
                  treatmentParts: fs?.treatmentParts?.length
                    ? fs?.treatmentParts?.join(',')
                    : '',
                },
                saveMappingBody: {
                  billing_category: fs.billingCategory || '',
                  hilist_code: fs.hiListCode || '',
                  insuranceCode: insuranceArray[0]?.insuranceCode || '',
                  is_reimbursement: medicalModalInfo?.isCouldBx || '',
                  limitId: limitId || '',
                },
                isCheckDuplicateNames: 1,
              }
            } else {
              submitBody = {
                treatmentServiceCatalog: {
                  ...fs,
                  treatmentCategory: fs.treatmentCategory
                    ? fs.treatmentCategory
                    : ' ',
                  forceYearAccount: fs.forceYearAccount ? fs.forceYearAccount : 0,
                  treatmentParts: fs?.treatmentParts?.length
                    ? fs?.treatmentParts?.join(',')
                    : '',
                },
                saveMappingBody: {
                  billing_category: fs.billingCategory || '',
                  hilist_code: fs.hiListCode || '',
                  insuranceCode: insuranceArray[0]?.insuranceCode || '',
                  is_reimbursement: medicalModalInfo?.isCouldBx || '',
                  limitId: medicalModalInfo?.limitId || '',
                },
                isCheckDuplicateNames: 1,
              }
            }
            dispatch(
              submitExamineAsync(submitBody)
            )
              .then(unwrapResult)
              .then((res: any) => {
                props.onOk()
                refreshMessage()
              })
              .catch((e:any) => {
                if (e?.message.startsWith("诊疗项目名称重复")) {
                  Modal.confirm({
                    centered: true,
                    title: "项目名称重复提醒",
                    content: (
                      '该项目已添加，请确认是否继续添加'
                    ),
                    okText: "继续添加",
                    cancelText: "返回",
                    icon: null,
                    onOk: () => {
                      dispatch(
                        submitExamineAsync({
                          ...submitBody,
                          isCheckDuplicateNames: 0,
                        })
                      )
                        .then(unwrapResult)
                        .then(() => {
                          props.onOk()
                          refreshMessage()
                        })
                    },
                  })
                }
              })

          }}
          onFieldsChange={(vs, fs) => {
            const name = vs.find((f) => isSameName(f, 'name'))
            if (name) {
              dispatch(getZjWbCodes(name.value))
                .then(unwrapResult)
                .then((v: any) => {
                  form.setFieldsValue({
                    mnemonicCode: v?.pinYin,
                    wubiCode: v?.wuBi,
                  })
                })
              // form.setFieldsValue({
              // mnemonicCode: name.value
              //   ? pinyin(name.value, {
              //       pattern: 'first',
              //       toneType: 'none',
              //       separator: '',
              //     }).toUpperCase()
              //   : '',
              // })
            }
          }}
        >
          {/* 自费机构（未开通医保）不展示医保信息，高度自适应避免留白；医保机构保持原高度 */}
          <div style={{height: insuranceArray.length ? '600px' : 'auto',paddingRight:'10px',overflowY:'auto',overflowX:'hidden'}}>
          <div className={styles.title}>
            <p className={styles.titletext}>诊疗基本信息</p>
          </div>
          <Row gutter={20}>
            <Col span={15} style={{ marginLeft: 5 }}>
              <Form.Item
                label='项目名称'
                name='name'
                rules={[
                  { required: true, message: '项目名称必填' },
                  {
                    max: 50,
                    message: '最长50位',
                  },
                ]}
                labelCol={{ span: '3' }}
                wrapperCol={{ span: '21' }}
              >
                <Input
                  ref={inputRef}
                  onInput={(e: any) => {
                    setComponentItem({
                      ...componentItem,
                      name: e.target.value,
                    })
                  }}
                />
              </Form.Item>
            </Col>
            {!insuranceArray.length?<Col span={8}></Col>:<Col span={8}>
              <Button
                  type='primary'
                  style={{ float: 'left' }}
                  onClick={() => {
                    if (!insuranceArray.length) {
                      notification.error({ message: '请先开通医保！' })
                      return
                    }
                    setComponentItem({
                      name: '',
                      billingCategory: '30',
                      tenantSupplierName: '',
                      transitionScale: '',
                      approvalNumber: '',
                    })
                    setMedicalModalVisible(true)
                    setYBSearchTag(true)
                  }}
              >
                从医保目录搜索
              </Button>
            </Col>
            }
            <Col span={8}>
              <Form.Item
                label='费用代码'
                name='no'
                rules={
                  state == '新增'
                    ? [
                      { required: true, message: '商品编码必填' },
                      {
                        pattern: new RegExp(/^[0-9a-zA-Z.]{1,}$/, 'g'),
                        message: '请输入数字或字母',
                      },
                      {
                        max: 50,
                        message: '最长50位',
                      },
                    ]
                    : []
                }
              >
                <Input disabled={state === '修改' ? true : false} />
              </Form.Item>
            </Col>
            {/* <Col span={9}>
              <Button type="primary">中心目录添加</Button>
            </Col> */}
            <Col span={8}>
              <Form.Item
                label='开票项目'
                name='billingCategory'
                rules={[{ required: true, message: '开票项目必填' }]}
              >
                <Select
                  placeholder='开票项目'
                  allowClear
                  // suffixIcon={<CaretDownFilled />}
                  onChange={(e) => {
                    setComponentItem({
                      ...componentItem,
                      billingCategory: e,
                    })
                  }}
                >
                  {TreatmentBillingCategories.map((v) => {
                    return (
                      <Option value={v} key={v}>
                        {BillingCategoryName(v)}
                      </Option>
                    )
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label='助记码'
                name='mnemonicCode'
                rules={[
                  { required: true, message: '助记码必填' },
                  {
                    max: 50,
                    message: '最长50位',
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label='单位'
                name='accountUnit'
                rules={[
                  { required: true, message: '单位必填' },
                  {
                    max: 20,
                    message: '最长20位',
                  },
                ]}
              >
                <RecipeItemFieldInput
                  field={'accountUnit'}
                  disabled={false}
                  noSize={true}
                />
                {/* <Input /> */}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label='成本价'
                name='costPrice'
                rules={[
                  {
                    pattern: new RegExp(/^\d+(\.\d{1,5})?$/, 'g'),
                    message: '请输入数字!',
                  },
                ]}
              >
                <Input
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ position: 'relative' }}>
              <Form.Item
                label='零售单价'
                name='retailPrice'
                rules={[
                  {
                    required: true,
                    message: '零售单价必填',
                  },
                  {
                    pattern: new RegExp(/^\d+(\.\d{1,5})?$/, 'g'),
                    message: '请输入数字!',
                  },
                ]}
              >
                {form.getFieldValue('hilistName') && insuranceArray?.length ?
                  <Input
                    style={{ width: '292px' }}
                  /> :
                  <Input
                    style={{ width: '100%' }}
                  />}
              </Form.Item>
              {form.getFieldValue('hilistName') && insuranceArray.length ? (
                <Button
                  style={{ position: 'absolute', top: 0, right: 11 }}
                  type='primary'
                  onClick={() => {
                    if (
                      form.getFieldValue('hilistPricUplmtAmt') >= 99999 ||
                      form.getFieldValue('hilistPricUplmtAmt') == 0
                    ) {
                      return
                    } else {
                      form.setFieldsValue({
                        retailPrice: form.getFieldValue('hilistPricUplmtAmt'),
                      })
                    }
                  }}
                >
                  同步限价
                </Button>
              ) : (
                <></>
              )}
            </Col>
            <Col span={8}>
              <Form.Item label='项目分类' name='treatmentCategory'>
                {/* <Input maxLength={6} /> */}
                <Select
                  placeholder='项目分类'
                  allowClear
                // suffixIcon={<CaretDownFilled />}
                >
                  {props.categoryList &&
                    props.categoryList.map((v: any) => {
                      if (v.name != '全部') {
                        return (
                          <Option value={v.name} key={v.id}>
                            {v.name}
                          </Option>
                        )
                      }
                    })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name='treatmentParts' label='治疗部位'>
                <Select mode='multiple'>
                  <Option key={'鼻'}>鼻</Option>
                  <Option key={'耳'}>耳</Option>
                  <Option key={'前额'}>前额</Option>
                  <Option key={'头顶'}>头顶</Option>
                  <Option key={'枕后'}>枕后</Option>
                  <Option key={'下颌'}>下颌</Option>
                  <Option key={'颈椎'}>颈椎</Option>
                  <Option key={'咽喉'}>咽喉</Option>
                  <Option key={'肩'}>肩</Option>
                  <Option key={'胸'}>胸</Option>
                  <Option key={'腹部'}>腹部</Option>
                  <Option key={'肩胛区'}>肩胛区</Option>
                  <Option key={'腰'}>腰</Option>
                  <Option key={'脊柱'}>脊柱</Option>
                  <Option key={'手臂'}>手臂</Option>
                  <Option key={'手腕'}>手腕</Option>
                  <Option key={'手掌'}>手掌</Option>
                  <Option key={'臀部'}>臀部</Option>
                  <Option key={'大腿'}>大腿</Option>
                  <Option key={'膝'}>膝</Option>
                  <Option key={'小腿'}>小腿</Option>
                  <Option key={'足底'}>足底</Option>
                  {treatmentPartsList.map((v: any) => {
                    return (
                      <Option key={v.id} value={v.name}>
                        {v.name}
                      </Option>
                    )
                  })}
                </Select>
              </Form.Item>
              <div style={{ position: 'absolute', top: '5px', right: '20px' }}>
                <SettingOutlined
                  style={{ color: '#999999' }}
                  onClick={() => setEditTreatmentParts(true)}
                />
              </div>
            </Col>
            <Col span={8}>
              <Form.Item
                name='wubiCode'
                label='五笔码'
                rules={[
                  {
                    max: 50,
                    message: '最长50位!',
                  },
                ]}
              >
                <Input size='middle' allowClear />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name='tax'
                label='项目税率'
                rules={[
                  {
                    pattern: new RegExp(/^(0(\.\d{1,2})?|1(\.0{1,2})?)$/),
                    message: '请输入0~1之间的数字，支持小数点后两位',
                  },
                ]}
              >
                <Input
                  size='middle'
                  addonAfter={
                    <>
                      <Popover
                        content={
                          <div>
                            <p>
                              如果您接入了电子发票，且需要控制每个项目的税率，可以在此处填写该项目的税率，如果您属于免税机构，则不需要填写。
                            </p>
                            <p>
                              如果您需要批量修改所有项目的税率，也可与我们的服务人员联系。
                            </p>
                            <p>格式为：0~1，保留2位小数点，如0.03</p>
                          </div>
                        }
                        placement='bottom'
                        title='说明'
                      >
                        <QuestionCircleTwoTone />
                      </Popover>
                    </>
                  }
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name='sortNo'
                label='排序'
                rules={[
                  {
                    message: '请输入整数值',
                    pattern: new RegExp(/^[0-9]+$/),
                  },
                ]}
              >
                <Input size='middle' allowClear type='number' />
              </Form.Item>
            </Col>
          </Row>
          {/* 自费机构（未开通医保）不展示诊疗医保信息 */}
          {insuranceArray.length ? <>
          <div className={styles.title}>
            <p className={styles.titletext}>诊疗医保信息</p>
          </div>
          <Row gutter={20}>
            <Col span={12}>
              <Form.Item label='匹配医保'>
                <span
                  style={{ color: '#4783ff', cursor: 'pointer' }}
                  onClick={() => {
                    if (!insuranceArray.length) {
                      notification.error({ message: '请先开通医保！' })
                      return
                    }
                    if (!componentItem.name || !componentItem.billingCategory) {
                      notification.error({ message: '请先完善诊疗基本信息！' })
                      return
                    }
                    setMedicalModalVisible(true)
                    setYBSearchTag(false)
                  }}
                >
                  {form.getFieldValue('hilistName') ? '重新匹配' : '匹配'}
                </span>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name='forceYearAccount'
                label='医保结算方式:'
              >
                <Radio.Group
                  defaultValue={0}
                >
                  <Radio value={0}>优先统筹</Radio>
                  <Radio value={1}>优先个账（包含本年、历年）</Radio>
                  <Radio value={2}>自费</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={20}>
            <Col span={8}>
              <Form.Item label='医保编码' name='hiListCode'>
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label='医保名称' name='hilistName'>
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label='甲乙分类' name='chrgitmLv'>
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label='医保单位' name='pacunt'>
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label='医保限价' name='hilistPricUplmtAmt'>
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label='项目说明' name='trtItemDscr'>
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={8} style={{marginLeft:'0px'}}>
              <Form.Item name='rewriteHilistCode' label='自定义医保国码'>
                <Input
                  size='middle'
                  addonAfter={
                    <>
                      <Popover
                        content={
                          <div>
                            <p>
                              当您知道此项目的医保国家编码，而医保匹配又搜索不到该项目时，您可以跳过匹配并直接填写医保国家编码。
                            </p>
                            <p>
                              在编码正确的情况下仍可进行医保结算；系统将会优先使用自定义医保国码进行医保结算。
                            </p>
                            <p>
                              请注意：使用自定义医保国码时，编码的限价与甲乙分类将不能正确展示，但不会影响医保刷卡与报销。
                            </p>
                          </div>
                        }
                        placement='bottom'
                        title='说明'
                      >
                        <QuestionCircleTwoTone />
                      </Popover>
                    </>
                  }
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name='zfblDescription' label='自付比例信息'>
                <Input size='middle' disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label='备注' name='remark' labelCol={{ span: '4' }} wrapperCol={{ span: '20' }}>
                <TextArea size='middle' showCount maxLength={200} />
              </Form.Item>
            </Col>
          </Row>
          </> : <></>}
          </div>
          <Row gutter={20} style={{paddingTop:'20px'}}>
            <Col span={12}>
              <Button
                type='primary'
                htmlType='submit'
                style={{ float: 'right' }}
              >
                确认
              </Button>
            </Col>
            <Col span={12}>
              <Button
                style={{ float: 'left' }}
                onClick={() => {
                  if (props?.info?.copyFlag) {
                    dispatch(logoutorEnableExamineAsync(props?.info?.copyId))
                      .then(unwrapResult)
                      .then(() => {
                        refreshMessage()
                      })
                  } else {
                    refreshMessage()
                  }
                }}
              >
                {props?.info?.copyFlag ? '删除' : '取消'}
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
      <SettingTreatmentParts
        isSettingTreatmentParts={editTreatmentParts}
        onCancel={() => {
          setEditTreatmentParts(false)
        }}
        onOk={() => {
          setEditTreatmentParts(false)
        }}
        refresh={() => {
          dispatch(defaultXianBingListAsync(2))
            .then(unwrapResult)
            .then((res) => {
              setTreatmentPartsList(res)
            })
        }}
      />

      <MedicalModal
        visible={medicalModalVisible}
        onOk={() => {
          setMedicalModalVisible(false)
        }}
        onCancel={() => {
          setMedicalModalVisible(false)
        }}
        onRecord={(item) => {
          setMedicalModalInfo(item)
          form.setFieldsValue({
            hiListCode: item.hiListCode,
            hilistName: item.hilistName,
            chrgitmLv: getChrgitmLvName(item.chrgitmLv),
            pacunt: item.pacunt,
            hilistPricUplmtAmt: item.hilistPricUplmtAmt,
            trtItemDscr: item.trtItemDscr,
          })
          if (form.getFieldValue('hilistPricUplmtAmt') >= 99999) {
            form.setFieldsValue({
              hilistPricUplmtAmt: 0,
            })
          } else {
            form.setFieldsValue({
              hilistPricUplmtAmt: item.hilistPricUplmtAmt,
            })
          }
          if (YBSearchTag) {
            form.setFieldsValue({
              //顺便回写基础目录信息
              name: item.hilistName,
              mnemonicCode: item?.mnemonicCode,
              wubiCode: item?.wubiCode,
              // mnemonicCode: pinyin(item.hilistName, {
              //   pattern: 'first',
              //   toneType: 'none',
              //   separator: '',
              // }).toUpperCase(),
              no: item.no || form.getFieldValue('no'),
              accountUnit: item.pacunt || form.getFieldValue('accountUnit'),
              billingCategory:
                item.billingCategory || form.getFieldValue('billingCategory'),
              retailPrice:
                item.retailPrice || form.getFieldValue('retailPrice'),
              treatmentCategory:
                item.treatmentCategory ||
                form.getFieldValue('treatmentCategory'),
            })
          }
          dispatch(getZjWbCodes(item.hilistName))
            .then(unwrapResult)
            .then((v: any) => {
              form.setFieldsValue({
                mnemonicCode: v?.pinYin,
                wubiCode: v?.wuBi,
              })
            })
          notification.success({ message: '匹配成功！' })
          setMedicalModalVisible(false)
        }}
        componentItem={{
          ...componentItem,
          insuranceCode: insuranceArray.length
            ? insuranceArray[0].insuranceCode
            : '',
        }}
        isTreatmentCatalog={true}
      />
    </div>
  )
}

// JSON parse error: Cannot deserialize value of type `java.math.BigDecimal` from String "个": not a valid representation; nested exception is com.fasterxml.jackson.databind.exc.InvalidFormatException: Cannot deserialize value of type `java.math.BigDecimal` from String "个": not a valid representation↵ at [Source: (PushbackInputStream); line: 1, column: 100] (through reference chain: org.springblade.treatmentcatalog.entity.TreatmentServiceCatalog["unitPrice"])
